module.exports = __webpack_public_path__ + "img/1389241238.8cb13034.jpg";